import { render, staticRenderFns } from "./ManualTax.vue?vue&type=template&id=56c34ece&scoped=true"
import script from "./ManualTax.vue?vue&type=script&lang=js"
export * from "./ManualTax.vue?vue&type=script&lang=js"
import style0 from "./ManualTax.vue?vue&type=style&index=0&id=56c34ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c34ece",
  null
  
)

export default component.exports